import React from 'react';
import { useHistory } from 'react-router-dom';
import EmployeeFrame from './EmployeeFrame';
import { Button } from '../../ui/button';
import { CheckCircle2, Mail } from 'lucide-react';

const ThankYou = () => {
  const history = useHistory();
  return (
    <EmployeeFrame client='Unlimited Group'>
      <div className='flex-1 flex flex-col justify-center py-6 text-center'>
        <div className='w-16 h-16 rounded-full bg-success-bg flex items-center justify-center text-success mb-5 mx-auto'>
          <CheckCircle2 size={30} strokeWidth={1.5} />
        </div>
        <h1 className='font-display text-2xl leading-tight mb-3'>Thanks — your answers are in</h1>
        <p className='text-[15px] text-muted-foreground leading-relaxed mb-6'>
          Your working pattern, home office and commute data has been added to your company's sustainability report.
        </p>

        <div className='rounded-xl border border-border bg-background/50 p-4 mb-5 text-left'>
          <div className='flex items-center gap-2 text-xs uppercase tracking-[0.14em] text-muted-foreground mb-2'>
            <Mail size={12} strokeWidth={1.5} />
            What happens next
          </div>
          <div className='text-sm leading-relaxed'>
            Your employer will see aggregate totals by office location — your individual answers are not shown. If you
            realise you made a mistake, you can use your original email link within 24 hours to amend.
          </div>
        </div>
      </div>

      <Button size='lg' variant='outline' className='w-full' onClick={() => history.push('/prototype/wfh-survey/employee/welcome')}>
        Preview again from the start
      </Button>
    </EmployeeFrame>
  );
};

export default ThankYou;
